import { defineCustomElement } from '@tyler-components-web/core';
import { OmnibarAppLauncherButtonComponent } from './omnibar-app-launcher-button';
export * from './omnibar-app-launcher-button-constants';
export * from './omnibar-app-launcher-button';
export function defineOmnibarAppLauncherButtonComponent() {
    defineCustomElement(OmnibarAppLauncherButtonComponent);
}
